import React, { useState } from 'react'
import cn from 'classnames'
import { filter, some, get, head, find } from 'lodash'
import Button from './Button'
import styles from './QuickMenuSearch.module.scss'

const QuickMenuSearch = ({ className, query, menuItems, setQuickSearchFlag, highlightedIds, setHighlightedIds, setFocusedItemId, quickSearchRef, setSelectedCategory }) => {
  const classNames = cn(styles.quickMenuSearch, className)
  const [focusedItemIndex, setFocusedItemIndex] = useState(0)

  const focus = get(quickSearchRef, 'current.focus', () => {}).bind(get(quickSearchRef, 'current', () => {}))

  const queryMatch = (query, item) => {
    return item.name.toUpperCase().includes(query.toUpperCase()) && !item.isModifier
  }

  const getNewSearchParams = (query) => {
    const highlightedIds = filter(menuItems, item =>
      queryMatch(query, item)
    ).map(item => item.id)

    const focusedItemId = head(highlightedIds)
    return {
      query,
      highlightedIds,
      focusedItemId,
    }
  }

  const resetState = (query) => {
    setFocusedItemIndex(0)
    setHighlightedIds({query: query, highlightedIds: [], focusedItemId: undefined})
  }

  const clearInput = () => {
    focus()
    resetState('')
  };

  const closeSearch = () => {
    setQuickSearchFlag(false)
    resetState('')
  }

  const queryUpdate = query => {
    const anyMatchingItems = some(menuItems, item => {
      return queryMatch(query, item)
    })

    if (!anyMatchingItems) {
      resetState(query)
      return
    }

    if (query) {
      setFocusedItemIndex(1)
      const newSearchParams = getNewSearchParams(query)
      setHighlightedIds(newSearchParams)
      setSelectedCategory(getSelectedCategoryParams(newSearchParams.focusedItemId))
    } else {
      clearInput()
    }
  };

  const style = {fill: "white"}
  const chevron = <svg height="32" width="32" >
  <polygon points="4,24 16,12 28,24 30,22 16,8 2,22" style={style} />
  </svg>

  const X_SVG = <svg width="24" height="24" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/></svg>

  const  getSelectedCategoryParams = (focusedItemId) => {
    const selectedCategoryId = find(menuItems, (item) => item.id === focusedItemId)?.categoryId ?? ''
    return { id: selectedCategoryId, search: false, highlight: true }
  }

  const adjustFocusedItemIndex = val => {
    if (query) {
      const newIndex =
        val < 1 ? 1 : val >= highlightedIds.length ? highlightedIds.length : val
      setFocusedItemId(highlightedIds[newIndex -1])
      setFocusedItemIndex(newIndex)
      setSelectedCategory(getSelectedCategoryParams(highlightedIds[newIndex -1]))
    }
    focus()
  };

  const overlay = query ? (
    <>
      <div className={styles.cartSidebarOverlay}></div>
      <div className={styles.navbarOverlay}></div>
    </>
  ) : null;

  return (
    <div className={classNames}>
    {overlay}
      <div className={styles.searchContainer}>
        <div className={styles.doneButton} onClick={closeSearch}> Done </div>
        <div className={styles.inputContainer}>
          <input className={styles.quickSearchInput} type="text" value={query} autoComplete="off" ref={quickSearchRef} autoFocus onChange={(e)=> queryUpdate(e.target.value) }/>
          <div className={styles.clearButton} onClick={clearInput}>{X_SVG}</div>
        </div>
        <div className={styles.focusedItemIndex}>{focusedItemIndex}/{highlightedIds.length}</div>
        <Button className={styles.upArrow} onClick={() => adjustFocusedItemIndex(focusedItemIndex - 1)}>{chevron}</Button>
        <Button className={styles.downArrow} onClick={() => adjustFocusedItemIndex(focusedItemIndex + 1)}>{chevron}</Button>
      </div>
    </div>
  )
}

export default QuickMenuSearch
